function Agent() {
    "use strict";

    this.__type = 'Agent:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.FirstName = '';
    this.FullName = '';
    this.LastName = '';

    this.DisplayType = 1;

    this.DoNotifyDuringOffHours = false;
    this.DutyOfficerId = -1;
    this.IsActive = true;
    this.IsDutyOfficer = false;
    this.IsOnTheClock = false;
    this.IsSupervisor = false;
    this.OrganizationId = -1;
    this.PrimaryEmail = '';
    this.SecondaryEmail = '';
    this.SupervisorTypeId = -1;
    this.TimeZoneId = 1;
    this.TypeId = 1;
    this.UserId = -1;

    // 4.3 release items
    this.FirstContactName = '';
    this.FirstContactMethodId = 2;
    this.FirstContactValue = '';
    this.SecondContactName = '';
    this.SecondContactMethodId = 2;
    this.SecondContactValue = '';
    this.ThirdContactName = '';
    this.ThirdContactMethodId = 2;
    this.ThirdContactValue = '';

    this.FirstContactConfirmedFlag = -1
    this.SecondContactConfirmedFlag = -1
    this.ThirdContactConfirmedFlag = -1


    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = Agent;
}